<template>
  <div id="navbar">
    <div class="nitro p-3 text-center d-md-none">
      <router-link to="/">
        <img
          src="/images/logo_nitro_mobile.svg"
          alt="Nitro Logo"
          style="width: auto; height: 40px;"
        >
      </router-link>
    </div>
    <nav class="d-flex flex-column flex-md-row align-items-center p-2 nitro justify-content-md-end">
      <div class="d-flex align-items-center">
        <div class="d-flex flex-md-row-reverse">
          <PlatformList />
        </div>
      </div>
    </nav>
  </div>
</template>

<script>

import PlatformList from "@/common/components/PlatformList.vue"

export default {
  components: {
    PlatformList,
  },
}
</script>
<style lang="scss" scoped>
.navbar-brand {
  margin-right: 0 !important;
  font-size: 1.15em !important;
}
</style>
